import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { NzMessageService } from 'ng-zorro-antd';
import { HttpErrorResponse } from '@angular/common/http';

import { GlobalComponent, Result, UserData } from '../../environments/global';

@Component({
    selector: 'app-data',
    templateUrl: 'ordine.component.html',
    styleUrls: ['ordine.component.scss']
})
export class OrdineComponent implements OnInit {
     // TABLE VARS
     public dataSet = [];
     // COMPONENT VARS
     public isLoading: boolean = true;

    // ################################################
    // CLASS: CONSTRUCTOR
    public constructor(
        private router: Router,
        public g: GlobalComponent,
        private message: NzMessageService
    ) {}
    // ################################################
    // CLASS: ON INIT
    ngOnInit() {
        if (!this.g.checkUserData()) { this.router.navigateByUrl('/track/(trackContent:utente)'); }
        // SETUP TITLE
        this.g.trackTitle = '<i nz-icon nzType="user"></i> ' + this.g.userData.name + ' ' + this.g.userData.surname;

        // LOAD DATA
        this.loadData();
     }

    loadData() {
        this.isLoading = true;
        const query: string = 'SELECT * from chk_orders WHERE `company`="' + this.g.userData.company + '" and `status` = true';
        this.g.mysql(query)
            .subscribe((res: Result) => {
                this.isLoading = false;
                this.dataSet = res.data;
            }, (error: HttpErrorResponse) => {
                this.isLoading = false;
                this.message.error('Si è vericato un errore non previsto:<br>' + error.statusText, { nzDuration: 5000 });
            });
    }

    selectRow(id: string) {
        this.router.navigateByUrl('/track/(trackContent:tempo)?orderid=' + id);
    }

    goback() {
        this.g.userData = {} as UserData;
        this.router.navigateByUrl('/track/(trackContent:utente)');
    }
    gocheck() {
        this.router.navigateByUrl('/track/(trackContent:check)');
    }
}
